import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';

import { Spinner } from 'shared-components/decorators/spinner';

import Button from '../elements-buttons/Button';
import { useStripeElements } from './utils';

export const CheckoutButton = ({ canExpressCheckout, buttonProps = {} }) => {
  const [showDefaultButton, setShowDefaultButton] = useState(true);

  const { selectedWallet, elements, allWallets, onSubmit, isSubmitting } = useStripeElements();

  useEffect(() => {
    elements?.getElement('expressCheckout')?.destroy();

    if (!selectedWallet || selectedWallet === 'card' || !elements) {
      setShowDefaultButton(true);
      return;
    }

    setShowDefaultButton(selectedWallet === 'card');

    try {
      const config = allWallets.reduce((acc, wallet) => ({ ...acc, [wallet]: 'never' }), {});

      const newExpressCheckoutElement = elements.create('expressCheckout', {
        paymentMethods: {
          ...config,
          [selectedWallet]: 'auto',
        },
        buttonType: {
          applePay: 'book',
          googlePay: 'book',
        },
      });

      newExpressCheckoutElement.mount('#express-checkout-element');

      newExpressCheckoutElement.on('click', (event) => {
        const canCheckout = canExpressCheckout();
        if (canCheckout) {
          event.resolve();
        }
      });

      newExpressCheckoutElement.on('confirm', () => {
        onSubmit();
      });

      return () => {
        newExpressCheckoutElement.destroy();
      }
    } catch (e) {
      console.log('#Error when creating an express element', e);
    }
  }, [selectedWallet, elements, allWallets, canExpressCheckout]);

  const buttonAttributes = useMemo(() => ({
    ...(buttonProps.attributes || {}),
    style: {
      ...((buttonProps.attributes || {}).style || {}),
      display: showDefaultButton ? 'block' : 'none',
    },
  }), [buttonProps, showDefaultButton]);

  const showWalletButton = !showDefaultButton && !isSubmitting;
  const showSpinner = !showDefaultButton && isSubmitting;

  return <>
    <div
      id="express-checkout-element"
      className={classNames({ hidden: !showWalletButton })}
    />
    <div className={classNames({ hidden: !showSpinner })}>
      <Spinner additionalStyle="gray" />
    </div>
    <Button
      {...buttonProps}
      disabled={buttonProps.disabled || !showDefaultButton}
      attributes={buttonAttributes}
      />
  </>;
};
